import { useGameInfo } from "@/app/OvertimePages/SingleGameContent"
import { OpponentLogo } from "@/components/dataDisplay"
import { Href } from "@/components/navigation"
import { Icon, type IconName } from "@/components/ui"
import TimeValue from "@/compositions/TimeValue"
import { getGameDateTime } from "@/helpers/getters"
// Using native JavaScript sort instead of lodash
import React, { useMemo } from "react"
import { Condition } from "@/compositions/event/Markets/OvertimeMarkets"
import { useMedia } from "@/contexts"

const OvertimeTopEventCard: React.FC<any> = ({ game }) => {
  const { gameInfo } = useGameInfo(game as any)
  const { sport, league, country, participants, startsAt, title } = gameInfo
  const { isMobileView } = useMedia()
  const { date, time } = getGameDateTime(
    startsAt instanceof Date ? startsAt.getTime() : +startsAt
  )

  const sortedChildMarkets = useMemo(() => {
    const marketsWithTwoOdds = game.childMarkets.filter(
      market => market.odds?.length === 2
    )
    return marketsWithTwoOdds.sort((a, b) => {
      if (a.line !== b.line) {
        return a.line - b.line
      }
      return b.odds - a.odds
    })
  }, [game.childMarkets])

  if (isMobileView) {
    return (
      <Href to={`${sport.slug}/${country.slug}/${league.slug}/${game.gameId}`}>
        <div className="bg-card-border-bottom p-px rounded-md overflow-hidden">
          <div className="bg-gradient-event-card p-4 rounded-md">
            <div className="flex items-center justify-center text-accent-grey-200 text-caption-13 hover:underline">
              <Icon
                className="size-4 mr-2 flex-none"
                name={`sport/${sport.slug}` as IconName}
              />
              <span className="text-ellipsis whitespace-nowrap overflow-hidden">
                {country.name}
              </span>
              <div className="size-[2px] rounded-full bg-accent-grey-700 mx-1" />
              <span className="text-ellipsis whitespace-nowrap overflow-hidden">
                {league.name}
              </span>
            </div>
            <div className="mt-3 flex items-center justify-between px-7">
              <OpponentLogo image={participants[0].image} size={48} />
              <div className="text-caption-12 text-center">
                <div className="text-accent-grey-200">{date}</div>
                <div className="font-semibold mt-[2px]">
                  <TimeValue time={time} />
                </div>
              </div>
              <OpponentLogo image={participants[1].image} size={48} />
            </div>
            <div className="mt-5 text-caption-13 font-semibold text-center text-ellipsis whitespace-nowrap overflow-hidden">
              {title}
            </div>
            <div
              className="space-y-2 rounded-sm p-2"
              onClick={e => e.stopPropagation()}
            >
              <Condition
                key={`${game.gameId}-${sortedChildMarkets[0]?.gameId}-${sortedChildMarkets[0]?.typeId}-${sortedChildMarkets[0]?.line}-${sortedChildMarkets[0]?.playerProps?.playerId || "no-player"}`}
                condition={sortedChildMarkets[0]}
                marketName="game.name"
                market={game}
                isGameOpen
              />
            </div>
          </div>
        </div>
      </Href>
    )
  }

  return (
    <div className="bg-card-border-bottom p-px rounded-md overflow-hidden">
      <div className="bg-gradient-event-card p-4 rounded-md">
        <Href
          to={`${sport.slug}/${country.slug}/${league.slug}/${game.gameId}`}
          className="flex items-center justify-center text-accent-grey-200 text-caption-13 hover:underline"
        >
          <Icon
            className="size-4 mr-2 flex-none"
            name={`sport/${sport.slug}` as IconName}
          />
          <span className="text-ellipsis whitespace-nowrap overflow-hidden">
            {country.name}
          </span>
          <div className="size-[2px] rounded-full bg-accent-grey-700 mx-1" />
          <span className="text-ellipsis whitespace-nowrap overflow-hidden">
            {league.name}
          </span>
        </Href>
        <div className="mt-3 flex items-center justify-between px-7">
          <OpponentLogo image={participants[0].image} size={48} />
          <div className="text-caption-12 text-center">
            <div className="text-accent-grey-200">{date}</div>
            <div className="font-semibold mt-[2px]">
              <TimeValue time={time} />
            </div>
          </div>
          <OpponentLogo image={participants[1].image} size={48} />
        </div>
        <div className="mt-5 text-caption-13 font-semibold text-center text-ellipsis whitespace-nowrap overflow-hidden">
          {title}
        </div>
        <div className="space-y-2 rounded-sm p-2">
          <Condition
            key={`${game.gameId}-${sortedChildMarkets[0]?.gameId}-${sortedChildMarkets[0]?.typeId}-${sortedChildMarkets[0]?.line}-${sortedChildMarkets[0]?.playerProps?.playerId || "no-player"}`}
            condition={sortedChildMarkets[0]}
            marketName="game.name"
            market={game}
            isGameOpen
          />
        </div>
      </div>
    </div>
  )
}

export default OvertimeTopEventCard
